module.exports = __webpack_public_path__ + "img/zlindex17.c820a1a0.png";